import $ from 'jquery';

import { FireComponent } from '@base';

export class Filters extends FireComponent {
  constructor(id) {
    super(id);
  }

  get elements() {
    return {
      $toggle: this.$component.find('[data-filters-toggle]'),
      $exposed: this.$component.find('[data-drupal-exposed]'),
      $clear: this.$component.find('[data-drupal-selector="edit-reset"]'),
    };
  }

  _toggleFilters() {
    this.elements.$toggle.on('click', (event) => {
      $(event.target).toggleClass('active');
      this.elements.$exposed.slideToggle(200);

      let expanded = $(event.target).get(0).getAttribute('aria-expanded');
      if (expanded === 'false') {
        $(event.target).get(0).setAttribute('aria-expanded', 'true');
      } else {
        $(event.target).get(0).setAttribute('aria-expanded', 'false');
      }
    });
  }

  _clearForm() {
    if (this.elements.$clear.length > 0) {
      let alertAnnounced = false;
      let self = this;

      this.elements.$clear.get(0).addEventListener('click', function (e) {
        if (alertAnnounced) {
          alertAnnounced = false;
          return;
        }

        e.preventDefault();

        //create element for screen readers to announce filters were cleared
        //then remove after it's announced.
        let alert = document.createElement('div');
        alert.setAttribute('role', 'alert');
        alert.setAttribute('aria-live', 'polite');
        alert.classList.add('sr-only');
        alert.innerText = 'Filter cleared successfully.';
        self.$component.get(0).appendChild(alert);
        setTimeout(() => {
          alert.remove();
        }, 2000);

        alertAnnounced = true;
        $(this).trigger('click');
      });
    }
  }

  _ada() {
    // to prevent duplicates, update `id` and `for` attributes to append `-mobile` or `-desktop` accordingly to filter groups
    const indentifier = this.elements.$exposed.get(0) ? this.elements.$exposed.get(0).dataset.drupalExposed : null;
    if (indentifier && (indentifier === 'desktop' || indentifier === 'mobile')) {
      const labels = this.elements.$exposed.get(0).querySelectorAll('label');
      const inputs = this.elements.$exposed.get(0).querySelectorAll('input, select');

      labels.forEach((label) => {
        const attr = label.getAttribute('for');
        if (attr) {
          label.setAttribute('for', `${attr}-${indentifier}`);
        }
      });

      inputs.forEach((input) => {
        const attr = input.getAttribute('id');
        if (attr) {
          input.setAttribute('id', `${attr}-${indentifier}`);
        }
      });
    }
  }

  init() {
    if (!this.componentExists) return;

    this._toggleFilters();
    this._clearForm();
    this._ada();
  }
}
